import React from 'react';
import { Link } from 'react-router-dom';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden" style={{
    minHeight: '92vh'
  }} aria-label="Hero" data-id="element-251">
      {/* Background photo */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=1600&q=80)'
    }} data-id="element-252" />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60" data-id="element-253" />

      {/* Content — bottom-left */}
      <div className="absolute inset-0 flex flex-col justify-end" data-id="element-254">
        <div className="max-w-7xl mx-auto w-full px-8 sm:px-16 pb-20" data-id="element-255">
          {/* Eyebrow */}
          <p className="text-xs font-bold uppercase mb-4 inline-block px-3 py-1.5 rounded" style={{
          color: '#1a1a1a',
          letterSpacing: '0.25em',
          background: 'rgba(220,220,220,0.90)'
        }} data-id="element-256">
            No Appointment Needed
          </p>

          {/* H1 */}
          <h1 className="font-black text-white leading-tight max-w-4xl" style={{
          fontSize: 'clamp(2.5rem, 6vw, 4.5rem)'
        }} data-id="element-257">
            Stay on the Road with
            <br data-id="element-258" />
            Ameritech's Expert Service!
          </h1>

          {/* CTA */}
          <Link to="/contact" className="inline-block text-white font-black text-sm uppercase tracking-widest px-10 py-5 mt-8 transition-colors duration-200" style={{
          background: '#a30000',
          letterSpacing: '0.15em'
        }} onMouseEnter={e => e.currentTarget.style.background = '#8a0000'} onMouseLeave={e => e.currentTarget.style.background = '#a30000'} data-id="element-259">
            BOOK NOW
          </Link>
        </div>
      </div>

      {/* Scroll Down */}
      <div className="absolute bottom-8 right-8 text-white/60 text-sm font-medium select-none" data-id="element-260">
        Scroll Down ↓
      </div>
    </section>;
}